export default (grossIncomeAnnual) => {
    return grossIncomeAnnual / 12 * 0.75;
}
